<template>
  <div class="view">
    <div class="header">
      <img class="pattern" src="@/assets/landing/pattern.png" alt />
      <Demo1 class="demo1 hide-small" />
      <Demo2 class="demo2 hide-small" />

      <div class="header-container">
        <div class="title-container">
          <div class="title">KYC Infogreffe</div>
          <div class="info">La connaissance client authentique</div>
          <div class="button-container">
            <div class="main-button green" @click="$router.push({ name: 'contact' })">Contact</div>
          </div>
        </div>
      </div>
    </div>
    <div class="first-section">
      <MarieaImg class="mariea-img" />

      <div class="resume">
        <div class="title">KYC Infogreffe</div>
        <div class="description">
          Un outil de surveillance dédié à la connaissance du client basé sur les documents officiels
          <br />et certifiés par les greffiers des tribunaux de commerce, en temps réel.
        </div>
      </div>

      <div class="items">
        <div class="item">
          <div class="icon terrorism">
            <IconTerrorism />
          </div>
          <span class="info">Lutte anti-blanchiment et contre le financement du terrorisme</span>
        </div>
        <div class="item">
          <div class="icon fraud">
            <IconFraud />
          </div>
          <span class="info">Fraude et compliance</span>
        </div>
        <div class="item">
          <div class="icon risk">
            <IconRisk />
          </div>
          <span class="info">Gestion du risque client</span>
        </div>
      </div>
    </div>
    <div class="second-section">
      <section v-for="section in sections" :key="section.id" class="section-container">
        <div class="section-content">
          <div class="section-header">
            <div class="title" v-html="section.title"></div>
            <div class="description" v-html="section.resume"></div>
          </div>
          <div class="lines-container">
            <div v-for="(line, i) in section.lines" :key="i" class="line">
              <div class="line-content" v-html="line" />
            </div>
            <div v-if="section.id === 1" class="line">
              <div class="line-content" style="font-weight: bold; display: contents">Liste des professionnels assujettis :</div>
              <div class="line-content details" style="cursor: pointer" @click="finiancialShow = !finiancialShow">
                Financiers
                <div class="icon-chevron bottom"></div>
              </div>
              <div v-if="finiancialShow" class="line-content">
                <ul>
                  <li>Banques et établissements de crédits</li>
                  <li>Établissements de paiement, Établissements de monnaie électronique, Changeurs manuels</li>
                  <li>Compagnies d’assurances, Mutuelles et institutions de prévoyance</li>
                  <li>Intermédiaires en opérations de banque</li>
                  <li>Intermédiaires en assurances</li>
                  <li>Sociétés de gestion de portefeuilles</li>
                  <li>Entreprises d’investissements, Intermédiaires en financement participatif, - Conseillers en investissement financier</li>
                  <li>Commerçants et intermédiaires en monnaies virtuelles</li>
                  <li>Instituts d’émission</li>
                </ul>
              </div>
              <div class="line-content details" style="cursor: pointer" @click="nonFiniancialShow = !nonFiniancialShow">
                Non Financiers
                <div class="icon-chevron bottom"></div>
              </div>
              <div v-if="nonFiniancialShow" class="line-content">
                <ul>
                  <li>Notaires, Huissiers, Avocats</li>
                  <li>Casinos, Cercles, jeux de hasard, pronostics sportifs ou hippiques</li>
                  <li>Opérateurs de jeux en ligne</li>
                  <li>Experts-comptables</li>
                  <li>Commissaires aux comptes</li>
                  <li>Administrateurs de justice et mandataires judiciaires</li>
                  <li>Professionnels de l’immobilier</li>
                  <li>Commissaires-priseurs, sociétés de vente</li>
                  <li>Sociétés de domiciliation</li>
                  <li>Marchands de biens précieux</li>
                  <li>Agents sportifs</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="image" :style="`background: url(${section.image}) #B4C1D0;`" />
      </section>

      <div class="section2-container">
        <div class="header-container">
          <div class="title">Quels axes de connaissance client ?</div>
          <div class="sub-title-container">
            <div class="sub-title">KYC Infogreffe est un outil de surveillance, d'information authentique et de preuve.</div>
            <div class="menu">
              <div
                class="left"
                :class="{ possible: miniCardLeftPosition > 0 }"
                @click="miniCardLeftPosition > 0 ? (miniCardLeftPosition = miniCardLeftPosition - 1) : (miniCardLeftPosition = 0)"
              >
                <div class="icon-chevron left noscale"></div>
              </div>
              <div
                class="right"
                :class="{ possible: miniCardLeftPosition % 4 === 0 }"
                @click="miniCards.length % 4 !== 0 ? (miniCardLeftPosition = miniCardLeftPosition + 1) : (miniCardLeftPosition = miniCards.length)"
              >
                <div class="icon-chevron right noscale"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="toto" class="card-container" :style="{ 'margin-left': `-${leftMarginCards}px` }">
        <div v-for="card in miniCards" :key="card.name" class="mini-card">
          <div class="title">{{ card.name }}</div>
          <div class="description">{{ card.description }}</div>
        </div>
      </div>
    </div>

    <div class="section second">
      <div class="resume">
        <div class="title">Pourquoi choisir KYC Infogreffe ?</div>
        <div class="description">
          Infogreffe garantit la diffusion d'une information fiable sur les entreprises, certifiée par les greffiers des tribunaux de commerce. Ces données sont
          mises à votre disposition au sein de la solution KYC Infogreffe.
        </div>
      </div>

      <div class="card-container">
        <div v-for="(card, i) in cards" :key="i" class="card">
          <div class="card-header">
            <div class="icon">
              <component :is="card.icon" />
            </div>
            <div class="title">{{ card.title }}</div>
          </div>

          <div class="separator"></div>

          <div class="lines-container">
            <div v-for="(line, j) in card.lines" :key="j" class="line">{{ line }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="section3">
      <div class="section3-container">
        <div v-if="news.length" class="title-line">
          <div class="title">{{ $t('news') }}</div>
          <div class="button main-button hide-small" @click="$router.push({ name: 'news' })">{{ $t('allNews') }}</div>
        </div>

        <News :news="news" />
      </div>
    </div>
  </div>
</template>

<script>
import Demo1 from '@/assets/landing/demo1.svg';
import Demo2 from '@/assets/landing/demo2.svg';
import Icon1 from '@/assets/landing/icons/1.svg';
import Icon2 from '@/assets/landing/icons/2.svg';
import Icon3 from '@/assets/landing/icons/3.svg';
import MarieaImg from '@/assets/landing/mariea.svg';
import News from '@/components/News';

export default {
  components: { MarieaImg, Demo1, Demo2, News },

  data() {
    return {
      finiancialShow: false,
      nonFiniancialShow: false,
      leftMarginCards: 0,
      miniCardLeftPosition: 0,
      news: [],
      sections: [
        {
          id: 0,
          title: 'Pour quels besoins ?',
          resume:
            "KYC Infogreffe vous permet de vérifier l'ensemble des données certifiées sur chacun de vos clients, prospects et partenaires, afin de répondre aux obligations de lutte contre le blanchiment d’argent et le financement du terrorisme (LCB-FT).",
          lines: [
            '<div style="font-weight: bold;display: contents;">Remplissez vos obligations en matière de LCB-FT</div> en vous appuyant sur une technologie innovante combinée à l\'expertise métier des greffiers des tribunaux de commerce.',
            '<div style="font-weight: bold;display: contents;">Réduisez vos risques</div> et documentez vos décisions en vous appuyant sur des informations fiables et certifiées, actualisées quotidiennement.',
            '<div style="font-weight: bold;display: contents;">Simplifiez vos process KYC</div> grâce à un portail en ligne, avec des données également accessibles par échange de fichiers (API).',
            "<div style=\"font-weight: bold;display: contents;\">Surveillez l'ensemble des données certifiées sur chacun de vos clients,</div> prospect et partenaires afin de réduire les risques d'usurpation d'identité, de blanchiment d'argent, de fraude et de financement du terrorisme.",
            '<div style="font-weight: bold;display: contents;">Conservez des données au moins 5 ans</div> après la fin de la relation client.',
          ],
          image: '/assets/landing2.jpg',
        },
        {
          id: 1,
          title: 'Pour qui ?',
          resume:
            'Outil destiné aux professionnels assujettis aux exigences en matière de LCB-FT (<a style="text-decoration: underline;cursor:pointer;display: contents;" href="https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000020196700&cidTexte=LEGITEXT000006072026">articles L561 et suivants du code monétaire et financier</a>).',
          lines: [
            '<div style="font-weight: bold;display: contents;">Dotez votre dispositif d’une solution renforçant la conformité.</div> Documentez vos diligences de surveillance anti-blanchiment avec des pièces authentiques et à jour. Partagez vos notes dans un portail dédié à l\'équipe compliance.',
          ],
          image: '/assets/landing1.jpg',
        },
      ],
      cards: [
        {
          title: 'Sécurité juridique',
          icon: Icon1,
          lines: ['Données certifiées et actualisées quotidiennenement par les professionnels', 'Conformité aux obligations LCB-FT'],
        },
        {
          title: 'Simplicité',
          icon: Icon3,
          lines: ['Traitement automatisé et alertes quotidiennes', 'Portail personnalisable à vos équipes et enjeux de vigilance'],
        },
        {
          title: 'Savoir-faire',
          icon: Icon1,
          lines: ['Expertise juridique des greffiers des tribunaux de commerce', 'Technologie en connexion directe aux bases de données Infogreffe'],
        },
        {
          title: 'Preuve',
          icon: Icon2,
          lines: ['Justification de ses diligences', 'Conservation des données au moins 5 ans après la fin de la relation client'],
        },
      ],
      miniCards: [
        {
          name: 'Identité',
          description: 'Connaissance de l’identité de l’entreprise et des personnes mentionnées au KBIS, ainsi que des modifications y afférents.',
        },
        {
          name: 'Bénéficaires effectifs',
          description: 'Connaissance des bénéficiaires effectifs et liens de détention, issus notamment du registre des bénéficiaires effectifs.',
        },
        {
          name: 'Associés',
          description: 'Connaissance des associés et de la répartition du capital issus des actes et statuts déposés au greffe.',
        },
        {
          name: 'Situation financière',
          description: 'Connaissance des chiffres clés et des états financiers annuels.',
        },
        {
          name: 'Activité et localisation',
          description: 'Identification de l’activité de l’entreprise, de son siège social et de ses établissements, des événements clés.',
        },
      ],
    };
  },

  watch: {
    miniCardLeftPosition(newValue) {
      this.leftMarginCards = newValue * 284;
    },
  },

  async mounted() {
    this.news = (await this.$store.dispatch('getNews')).items;
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
$greybackground-color: #f2f6f9;
.view {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  height: unset;
  margin-top: 90px;
}

.header {
  display: flex;
  overflow-x: hidden;

  justify-content: center;
  align-items: center;

  height: 624px;
  width: 100%;
  position: relative;

  background: colors.$lightblue-color;

  .pattern {
    position: absolute;
    left: -100px;
    bottom: 0;
    opacity: 0.3;
  }

  .demo1 {
    position: absolute;
    right: 0;
    border-radius: 5px 0 0 5px;
  }

  .demo2 {
    position: absolute;
    bottom: 60px;
    right: 474px;
    border-radius: 5px;
    box-shadow:
      0 3px 6px rgba(0, 0, 0, 0.16),
      0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .header-container {
    max-width: 1200px;
    width: 100%;

    z-index: 1;
  }

  .button-container {
    display: flex;

    margin-top: 64px;

    .main-button.green {
      background: colors.$lightgreen-color;
      margin-right: 24px;
    }

    .main-button.transparent {
      background: transparent;
      border: 2px solid colors.$white-color;
    }
  }

  .title-container {
    width: 488px;
    color: white;
    max-width: 1200px;

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 23px;
      letter-spacing: 0.05em;
      text-transform: capitalize;

      margin-bottom: 18px;
    }

    .info {
      font-style: normal;
      font-weight: 300;
      font-size: 46px;
      line-height: 54px;
    }

    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-sizing: border-box;
      padding: 0 12px;
      width: 100vw;

      .info {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
        font-size: 40px;
        line-height: 47px;
      }

      .button-container {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .green {
          margin: 0 0 30px 0;
        }

        .transparent {
          min-width: 168px;
          width: 168px;
        }
      }
    }
  }
}

.resume {
  max-width: 800px;
  margin-bottom: 78px;

  .title {
    font-weight: 500;
    font-size: 25px;
    line-height: 32px;

    text-align: center;

    margin: 16px 0;

    color: colors.$darkblue-color;
  }

  .description {
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    color: colors.$grey-color;
  }
}

.section {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  background: $greybackground-color;

  padding: 97px 0;
  padding-top: 194px;

  &.second {
    margin-top: 48px;
  }
}

.first-section {
  position: relative;
  @extend .section;

  .mariea-img {
    position: absolute;
    z-index: 0;
    right: 0;
    bottom: -54px;
  }

  .items {
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    max-width: 987px;
    width: 100%;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 284px;
    }

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 80px;
      width: 80px;
      background: colors.$green-color;
      border-radius: 50%;
    }

    .info {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: center;
      color: colors.$darkblue-color;
      margin-top: 24px;
    }

    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      .item {
        margin: 24px 0;
      }
    }
  }
}

.second-section {
  background: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 96px 0;
  position: relative;

  .section2-container {
    max-width: 1200px;
    width: 100%;

    .header-container {
      .title {
        font-weight: 500;
        font-size: 25px;
        line-height: 32px;
        margin: 16px 0;
        color: colors.$darkblue-color;
      }

      .sub-title-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;

        .sub-title {
          font-weight: normal;
          font-size: 17px;
          line-height: 22px;
          color: colors.$grey-color;
          justify-self: flex-start;
        }
        .menu {
          display: flex;
          align-items: center;

          .left,
          .right {
            border-radius: 50%;
            display: flex;
            flex-shrink: 0;
            width: 40px;
            height: 40px;
            margin: 0 15px;
            position: relative;
            .icon-chevron {
              background: rgba(225, 229, 234, 0.404);
            }

            &::after {
              border-color: #fff;
            }

            &.possible {
              cursor: pointer;
              .icon-chevron {
                background-color: colors.$lightgrey-color;
              }
              &:hover {
                .icon-chevron {
                  background: #e1e5ea;
                }
              }
            }
          }
        }
      }
    }

    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      width: 100vw;
      padding: 0 36px;
      box-sizing: border-box;
    }
  }
  .card-container {
    margin: 24px 0;
    left: 0;
    right: 0;
    max-width: 1200px;
    margin-bottom: -250px;

    .mini-card {
      display: flex;
      flex-direction: column;
      padding: 0 30px;
      flex-shrink: 0;
      box-sizing: border-box;

      width: 284px;
      height: 220px;
      background: colors.$lightblue-color;
      border-radius: 5px;
      transition: all 0.5s;

      margin-right: 24px;

      .title {
        font-weight: 500;
        font-size: 20px;
        line-height: 23px;
        color: colors.$white-color;

        margin: 16px 0;
        margin-top: 48px;
      }

      .description {
        font-size: 15px;
        line-height: 20px;

        color: colors.$white-color;
      }
    }

    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      width: calc(100vw);
      padding: 0 36px;
      box-sizing: border-box;
      overflow-x: scroll;
    }
  }

  .section-content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    margin-right: 124px;
    min-height: 480px;
  }

  .section-container {
    display: flex;
    max-width: 1024px;
    margin: 48px 0;
    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      flex-direction: column;
      .section-content {
        box-sizing: border-box;
        margin: 0 36px;
        .section-header,
        .lines-container {
          box-sizing: border-box;
        }
      }

      .image {
        width: 100%;
        height: 360px;
      }
    }
  }

  .section-header {
    border-left: 3px solid colors.$lightblue-color;
    padding-left: 16px;

    .title {
      font-weight: 500;
      font-size: 25px;
      line-height: 32px;
      color: colors.$darkblue-color;
      margin: 16px 0;
    }

    .description {
      font-weight: normal;
      font-size: 17px;
      line-height: 22px;
      color: #909fb2;
    }
  }

  .lines-container {
    margin: 36px 0;

    font-size: 15px;
    line-height: 20px;
    color: #5a6b83;

    .line {
      position: relative;

      display: flex;
      flex-direction: column;
      padding-left: 19px;

      margin: 16px 0;

      &::before {
        display: block;
        content: '';
        height: 6px;
        width: 6px;
        background: colors.$lightblue-color;
        border-radius: 50%;
        position: absolute;
        top: 7px;
        left: 0;
      }

      .line-content {
        &.details {
          color: colors.$grey-color;
          padding: 10px 0 0 0;
          font-weight: 500;
          font-size: 14px;
          display: flex;
          align-items: center;

          .icon-chevron {
            margin-left: 10px;
            &:after {
              transform: scale(0.8);
              border-color: colors.$grey-color;
            }
          }
        }
      }
    }
  }

  .image {
    width: 386px;
    flex-shrink: 0;
    background-position: center center !important;
    background-size: cover !important;
  }
}

.section-container:nth-child(2) {
  flex-direction: row-reverse;

  .section-content {
    margin-right: 0;
    margin-left: 124px;
  }
  @media only screen and (max-width: responsive.$layout-breakpoint-small) {
    flex-direction: column;
    .section-content {
      box-sizing: border-box;
      margin: 0 36px;
      .section-header,
      .lines-container {
        box-sizing: border-box;
      }
    }
  }
}

.card-container {
  display: flex;

  .card {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 284px;
    min-height: 364px;

    background: white;
    border-radius: 5px;

    margin: 0 12px;
  }

  .lines-container {
    margin: 0 24px;
    margin-top: 12px;

    .line {
      position: relative;

      font-size: 15px;
      line-height: 20px;
      color: colors.$darkgrey-color;

      padding-left: 12px;
      padding-right: 20px;
      margin: 16px 0;

      &::before {
        display: block;
        content: '';
        height: 6px;
        width: 6px;
        background: colors.$green-color;
        border-radius: 50%;
        position: absolute;
        top: 7px;
        left: 0;
      }
    }
  }

  .separator {
    border: 0.5px solid colors.$lightgreen-color;
    width: 30px;
  }

  .card-header {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    height: 50%;

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 59px;
      background: colors.$green-color;
      width: 59px;
      border-radius: 50%;
      margin: 0;
    }

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 23px;
      text-align: center;
      color: colors.$green-color;
    }
  }
  @media only screen and (max-width: responsive.$layout-breakpoint-small) {
    width: calc(100vw);
    padding: 0 12px;
    box-sizing: border-box;
    overflow-x: scroll;
    height: 480px;
    .card {
      flex-shrink: 0;
    }
  }
}

.section3 {
  display: flex;
  justify-content: center;
  padding-top: 97px;

  .section3-container {
    max-width: 1200px;
    width: 100%;
    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      width: calc(100vw);
      padding: 0 12px;
    }
  }

  .title-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-weight: 500;
    font-size: 25px;
    line-height: 32px;
    color: colors.$darkblue-color;
  }
}
</style>
